/**
 * gestion des vidéos
 *  - détecter si le consentement des cookies est donné
 *  - si oui, charger l'iframe youtube
 * - si non , bloquer les vidéo et afficher un message pour chaque slide
 *      - si le consentement est donné, charger l'iframe youtube
 */

var grVideoYoutube = require('../_grVideoYoutube');

( function( global, $ ) {

    // check if cookies consent is given
    // cookies consentment is managed by cookieyes
    
    var cookiesConsent = getCookieYesConsent();
    var isAdvertisementConsent = checkYoutubeConsent();

    document.addEventListener("cookieyes_consent_update", function (eventData) 
    {
        cookiesConsent = getCookieYesConsent();
        isAdvertisementConsent = checkYoutubeConsent();

        if(isAdvertisementConsent) {
            addYoutubeScript();
            window.onYouTubePlayerAPIReady = function () {
                handleSlider();
            };
        }
    });  

    var allSlides = $('[data-gallery] .c-slide');
    var galleryTitleContainer = $('[data-slide-title-target]');
    var galleryTextContainer = $('[data-slide-text-target]');
    var galleryCTAContainer = $('[data-slide-cta-target]');
    var dataGallery = $('[data-gallery]');

    if(!isAdvertisementConsent) {
        handleSlider();
    } else {
        addYoutubeScript();
        window.onYouTubePlayerAPIReady = function () {
            handleSlider();
        };
    }

    function handleSlider() {

        // instanciations

        var grVideos = document.querySelectorAll('[gr-video-youtube]');

        if(isAdvertisementConsent) {
            var videoInstances = instantiateYoutubeVideos(grVideos);
        }
        
        if (dataGallery) {
            var options = dataGallery.data('gallery');

            dataGallery.on('init', function (event, slick) { 
                var currentSlideIndex = slick.currentSlide;
                var currentSlideElement = slick.$slides[currentSlideIndex];
                var videoElement = currentSlideElement.querySelector('[gr-video-youtube] [data-id]');
                var videoContainer = currentSlideElement.querySelector('[gr-video-youtube]')
                
                if (videoElement && isAdvertisementConsent) {
                    var videoElementId = videoElement.getAttribute('data-id');
                    videoChangeHandler(videoElementId, videoInstances);
                } else if(videoContainer && !videoContainer.dataset.hasConsentMessage) {
                    addConsentMessage(videoContainer);
                }
            });

            dataGallery.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var currentSlideElement = slick.$slides[currentSlide];
                var currentSlideVideoElement = currentSlideElement.querySelector('[gr-video-youtube] [data-id]');

                if (currentSlideVideoElement && isAdvertisementConsent) {
                    var currentVideoElementId = currentSlideVideoElement.getAttribute('data-id');

                    $.each(videoInstances, function (index, videoInstance) {
                        if (videoInstance.ready) {
                            if (currentVideoElementId === videoInstance.videoId) {
                                videoInstance.pause();
                            }

                        } else {
                            videoInstance.selector.addEventListener('grVideoYoutubeOnPlayerReady', function (e) {
                                if (currentVideoElementId === videoInstance.videoId) {
                                    videoInstance.pause();
                                }
                            });
                        }
                    });
                }
            });

            dataGallery.on('afterChange', function (event, slick, currentSlide) {
                setTexts();

                var currentSlideElement = slick.$slides[currentSlide];
                var videoElement = currentSlideElement.querySelector('[gr-video-youtube] [data-id]');
                var videoContainer = currentSlideElement.querySelector('[gr-video-youtube]');

                if (videoElement && isAdvertisementConsent) {
                    var videoElementId = videoElement.getAttribute('data-id');
                    videoChangeHandler(videoElementId, videoInstances);
                } else if(videoContainer && !videoContainer.dataset.hasConsentMessage) {
                    addConsentMessage(videoContainer);
                }
            });

            dataGallery.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',
                prevArrow: $('[data-gallery-btn-prev]'),
                nextArrow: $('[data-gallery-btn-next]'),
                autoplay: true,
                autoplaySpeed: options && options.speed ? options.speed : 3000,
                infinite: false
            });

            // ajouter le texte pour la 1e slide
            setTexts();
        }
    }

    /**
     * Get the cookieyes consent cookie
     */
    function getCookieYesConsent() {
        var regex = /cookieyes-consent=([^;]+)/g;
        var match = null;
        match = document.cookie.match(regex);
        if (match) {
            match = match[0];
        }
        return match;
    }

    /**
     * Check if advertisement and analytics is given
     */
    function checkYoutubeConsent() {
        var consent = false;
        if(cookiesConsent) {
            // check if advertisement consent is given
            var regex = /advertisement:(\w+)/;
            var match = cookiesConsent.match(regex);
            if (match) {
                var advertisementValue = match[1];
                var advertisementConsent = advertisementValue === "yes" ? true : false;
            }

            // check if analytics consent is given
            regex = /analytics:(\w+)/;
            match = cookiesConsent.match(regex);
            if (match) {
                var analyticsValue = match[1];
                var analyticsConsent = analyticsValue === "yes" ? true : false;
            } 

            return advertisementConsent && analyticsConsent;
        }

        return consent;
    }

    /**
     * Add youtube script to the page
     */
    function addYoutubeScript() {
        // This code loads the IFrame Player API code asynchronously.
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/player_api';
        tag.async = true;
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    /**
     * Instantiate youtube videos
     * @param {grVideos} All videos to instantiate
     * @return {Object} All video instances
     */
    function instantiateYoutubeVideos(grVideos) {
        var all = {};
        var index;

        if (grVideos.length) {
            window.groots.grVideoYoutube = { instances: {} };
            all = grVideos;
            index = -1;
            while (all[++index]) {
                global.grVideoYoutube.instances[index] = new grVideoYoutube(all[index]);
            }
            return global.grVideoYoutube.instances;
        }
    }

    /**
     * Add a consent message to the slide
     */
    function addConsentMessage(currentSlideElement) {
        var newDiv = document.createElement('div');
        newDiv.classList.add('c-banner__video-message');
        newDiv.textContent = 'Vous devez accepter les cookies pour voir cette vidéo';
        currentSlideElement.appendChild(newDiv);
        currentSlideElement.dataset.hasConsentMessage = true;
        currentSlideElement.classList.add('c-banner__video--has-message');
    }

    /**
     * Handle video instance state and gallery autoplay.
     * @param {pVideoId} The current slide video ID
     * @param {pVideoInstances} All gr-youtube-vide instances
     */
    function videoChangeHandler(pVideoId, pVideoInstances) {
        $.each(pVideoInstances, function (index, videoInstance) {
            if (videoInstance.ready) {
                if (pVideoId === videoInstance.videoId) {
                    dataGallery.slick('slickPause');
                    videoInstance.play();
                }

            } else {
                videoInstance.selector.addEventListener('grVideoYoutubeOnPlayerReady', function (e) {
                    if (pVideoId === videoInstance.videoId) {
                        dataGallery.slick('slickPause');
                        videoInstance.play();
                    }
                });
            }

            videoInstance.selector.addEventListener('grVideoYoutubeOnVideoEnded', function (e) {
                if (pVideoId === videoInstance.videoId) {
                    videoInstance.replay();
                    videoInstance.pause();
                }

                setTimeout(function () {
                    dataGallery.slick('slickNext');
                    dataGallery.slick('slickPlay');
                }, 1000);
            });
        });
    }

    function setTexts() {
        var firstSlideIndex = dataGallery.slick('slickCurrentSlide');
        if(allSlides) {
            var galleryTitle = $(allSlides[firstSlideIndex]).attr('data-slide-title');
            var galleryText = $(allSlides[firstSlideIndex]).attr('data-slide-text');
            var galleryCTA = $(allSlides[firstSlideIndex]).attr('data-slide-cta');
            if(galleryTitle && galleryTitleContainer) {
                galleryTitleContainer.text(galleryTitle);
            }
            if(galleryText && galleryTextContainer) {
                galleryTextContainer.text(galleryText);
            }
            if(galleryCTA && galleryCTAContainer) {
                galleryCTA=JSON.parse(galleryCTA);
                if(galleryCTA.url) {
                    galleryCTAContainer.attr("href",galleryCTA.url);
                }
                if(galleryCTA.target) {
                    galleryCTAContainer.attr("target", "_blank");
                }
                if(galleryCTA.text) {
                    galleryCTAContainer.text(galleryCTA.text);
                }
                 
            }
        }
    }

    var $dataCarousels = $('[data-carousel]');
    
    $dataCarousels.each(function(){
        var $isTestimony = false;
        if ($(this).data("carousel") === "testimony") {
            $isTestimony = true;
        }

        $(this).slick({
            slidesToShow: $isTestimony ? 3 : 2 ,
            slidesToScroll: 2,
            infinite: false,
            arrows: false,
            lazyLoad: 'ondemand',
            variableWidth: !$isTestimony,
            centerMode: false,
            touchThreshold: 1000,
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: $isTestimony ? 1 : 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
    
        });
        // ajouter un scroll horizontal sur 'mousewheel'
        // hack trouvé sur stackoverflow : 
        // https://stackoverflow.com/questions/46508975/how-to-use-mouse-scroll-instead-of-drag-in-slick-js
    
        var scrollCount = null;
        var scroll= null;
        
        $(this).on('wheel', (function(e) {
            e.preventDefault();
        
            clearTimeout(scroll);
            scroll = setTimeout(function(){scrollCount=0;}, 200);
            if(scrollCount) return 0;
            scrollCount=1;
        
            if (e.originalEvent.deltaY < 0) {
                $(this).slick('slickPrev');
            } else {
                $(this).slick('slickNext');
            }
        }));
    });


}( window.groots, jQuery, require('slick-carousel')));
